import React from "react";

const inputCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";

const KPI_CONFIG = [
  { key: "open",          label: "Open",               color: "#00ff90"  },
  { key: "newToday",      label: "New Today",           color: "#60a5fa"  },
  { key: "slaRisk",       label: "SLA Risk/Breached",   color: "#f87171"  },
  { key: "awaitingMgr",   label: "Awaiting Manager",    color: "#fbbf24"  },
  { key: "avgFirstResp",  label: "Avg First Response",  color: "rgba(255,255,255,0.4)" },
  { key: "avgResolution", label: "Avg Resolution",      color: "rgba(255,255,255,0.4)" },
];

export default function TicketFilters({ view, setView, filters = {}, setFilters, kpis }) {
  const set = (k, v) => setFilters?.(f => ({ ...f, [k]: v }));

  return (
    <div className="rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] p-5 space-y-4">

      {/* Tabs */}
      <div className="flex gap-2">
        {[
          { key: "inbox",     label: "Team Inbox"          },
          { key: "approvals", label: "Approvals & Triage"  },
        ].map(t => (
          <button key={t.key} onClick={() => setView?.(t.key)}
            className={`text-xs px-4 py-2 rounded-full border transition-colors ${
              view === t.key
                ? "bg-[#00ff90]/15 border-[#00ff90]/40 text-[#00ff90]"
                : "bg-transparent border-white/10 text-white/40 hover:border-[#00ff90]/20 hover:text-white/60"
            }`}>
            {t.label}
          </button>
        ))}
      </div>

      {/* Filters */}
      <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
        <div className="md:col-span-2">
          <label className={labelCls}>Search</label>
          <input className={inputCls} placeholder="Title, ID or requester…"
            value={filters.search || ""} onChange={e => set("search", e.target.value)} />
        </div>
        <div>
          <label className={labelCls}>Priority</label>
          <select className={inputCls} value={filters.priority || "ALL"} onChange={e => set("priority", e.target.value)}>
            <option value="ALL">All</option>
            {["P1","P2","P3","P4"].map(p => <option key={p} value={p}>{p}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Status</label>
          <select className={inputCls} value={filters.status || "ALL"} onChange={e => set("status", e.target.value)}>
            <option value="ALL">All</option>
            {["New","In Progress","Waiting","Resolved","Closed"].map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Category</label>
          <select className={inputCls} value={filters.category || "ALL"} onChange={e => set("category", e.target.value)}>
            <option value="ALL">All</option>
            {["IT","HR","Payroll","Facilities","Security"].map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>From</label>
          <input type="date" className={inputCls} value={filters.from || ""} onChange={e => set("from", e.target.value)} />
        </div>
      </div>

      <div className="flex gap-4 flex-wrap">
        <label className="flex items-center gap-2 cursor-pointer">
          <input type="checkbox" checked={!!filters.onlySlaRisk} onChange={e => set("onlySlaRisk", e.target.checked)}
            className="w-4 h-4 rounded accent-[#00ff90]" />
          <span className="text-sm text-white/60">SLA at risk / breached only</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input type="checkbox" checked={!!filters.onlyAwaitingMgr} onChange={e => set("onlyAwaitingMgr", e.target.checked)}
            className="w-4 h-4 rounded accent-[#00ff90]" />
          <span className="text-sm text-white/60">Awaiting manager action only</span>
        </label>
      </div>

      {/* KPIs */}
      {kpis && (
        <div className="grid grid-cols-2 md:grid-cols-6 gap-3 pt-1 border-t border-white/5">
          {KPI_CONFIG.map(({ key, label, color }) => (
            <div key={key} className="rounded-lg border border-white/5 bg-white/3 p-3 text-center">
              <p className="text-lg font-bold" style={{ color }}>{kpis[key] ?? "—"}</p>
              <p className="text-xs text-white/30 mt-0.5">{label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}